if(!customElements.get('personalize-form')) {
  class PersonalizeForm extends HTMLElement {
    constructor() {
      super();

      const mainElement = this.closest('.product-main-element');
      const section = mainElement.closest('.shopify-section');
      (mainElement.personalizeFields =mainElement.personalizeFields || []);
      const fields = mainElement.personalizeFields;
      const container = section.querySelector('.personalize-module');
      const form = section.querySelector('.personalize-form');
      const formFieldsContainer = section.querySelector('.personalize-fields-wrap');
      const toggler = container ? container.querySelector('.personalize-toggle input[type="checkbox"]') : null;
      const bundleContainer = container ? container.querySelector('.bundle') : null;

      const fieldPushOrig = fields.push;
      const addField = (field)=>{
        if (formFieldsContainer) {
          formFieldsContainer.appendChild(field);
        }
      }
      fields.push = (...args)=>{
        fieldPushOrig.call(fields, ...args);
        [...args].forEach(field=>{
          addField(field);
        })
      }
      
      // initialize events

      fields.forEach((field)=>{
        addField(field);
      });

      function handleAttributes() {
        if (bundleContainer) {
          bundleContainer.querySelectorAll('input,select,textarea').forEach(input=>{
            if (toggler.checked) {
              if (!input.hasAttribute('name')) {
                input.setAttribute('name', input.getAttribute('data-name'));
              }
            } else {
              if (input.hasAttribute('name')) {
                input.removeAttribute('name');
              }
            }
          });
        }
      }

      if (container) {
        toggler.addEventListener('keydown', (e)=>{
          if (e.key=='Enter') {
            e.preventDefault();
            toggler.click();
          }
        });
        toggler.addEventListener('change', (e)=>{
          if (toggler.checked) {
            $s.expand([form]);
          } else {
            $s.collapse([form]);
          }
          handleAttributes();
          mainElement.dispatchEvent(new CustomEvent('bundleChange'));
        });
        container.addEventListener('keydown', (e)=>{
          if (e.key=='Enter') {
            e.preventDefault();
          }
        })

      }

      if (bundleContainer) {
        mainElement.addEventListener('quantityChange', handleItemsQuantity.bind(this));
      }

      function handleItemsQuantity(e) {
        const item = bundleContainer.querySelector('.bundle-item');
        const bundleItem = item.querySelector('input[value="related_multiple"]');
        if (bundleItem) {
          const quantity = item.querySelector('[data-name*="[quantity]"]');
          quantity.value = e.detail.quantity;
        }
        mainElement.dispatchEvent(new CustomEvent('bundleChange'));
      }     

    }

        
  }
  customElements.define('personalize-form', PersonalizeForm);
    
  class PersonalizeField extends HTMLElement {
    constructor() {
      super();
      const mainElement = this.closest('.product-main-element');
      const field = this;
      (mainElement.personalizeFields = mainElement.personalizeFields || []).push(field);
      const fields = mainElement.personalizeFields;
      const toggler = mainElement.querySelector('.personalize-toggle input[type=checkbox]');
      const observers = {};
      const textInput = this.querySelector('input[type="text"], select, textarea');
      const maxlength = textInput ? textInput.getAttribute('maxlength') / 1 : 0;

      let visible = null;
      this.hook = function(event, handler) {
        observers[event] = observers[event] || [];
        if (observers[event].indexOf(handler)==-1) {
          observers[event].push(handler);
        }
      }
      function emit(event) {
        (observers[event] || []).forEach(handler=>handler());
      }

      toggler?.addEventListener('change', handleAttributes);
      
      //change firing from input event even on radio buttons
      //field.addEventListener('change', (e)=>emit('change'));
      function fieldUIUpdate() {
        if (maxlength) {
          const counter = field.querySelector('.char-count');
          counter.innerHTML = '(' + textInput.value.length + '/' + maxlength + ')';
        }
      }
      field.addEventListener('input', (e)=>{
        fieldUIUpdate();
        emit('change'); 
      });

      field.getValue = function() {
        const input = visible ? field.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked, input[type="text"], select, textarea') : null;
        return input ? input.value : null;
      }

      //begin helper functions, used from eval(field.dataset.condition)
      
      const valueof = function(propName) {
        const dependencyField = fields.find(x=>propName==x.dataset.key);
        if (dependencyField) {
          dependencyField.hook('change', visibility);
          return dependencyField.getValue();
        }
        return null;
      }

      //end helper functions
      
      function handleAttributes() {
        field.querySelectorAll('input,select,textarea').forEach(input=>{
          if (visible && (!toggler || toggler.checked)) {
            if (!input.hasAttribute('name')) {
              input.setAttribute('name', input.getAttribute('data-name'));
            }
          } else {
            if (input.hasAttribute('name')) {
              input.removeAttribute('name');
            }
          }
        });
      }

      function visibility() {
        const prevVisible = visible;
        visible = true;
        
        if (visible && field.dataset.condition) {
          visible = eval(field.dataset.condition);
        }

        field.style.display = visible!=false ? '' : 'none';
        if (prevVisible !== visible) {
          emit('change');
          handleAttributes();
        }
      }

      fieldUIUpdate();
      visibility();
      field.classList.add('initialized');
    }
  }
  customElements.define('personalize-field', PersonalizeField);
}